import { useEffect } from 'react';
import { shouldCloseContextMenuOnPress } from 'utils/is-inside-context-menu';
import ContextMenu from './context-menu';
import { useContextMenu } from './context-menu-manager';

export default function GlobalContextMenu() {
  const { contextMenu, closeContextMenu } = useContextMenu();

  useEffect(() => {
    const handleClickOutside = () => {
      if (contextMenu.visible) {
        closeContextMenu();
      }
    };

    const handlePressOutside = (event: Event) => {
      if (shouldCloseContextMenuOnPress(contextMenu.visible, event.target)) {
        closeContextMenu();
      }
    };

    const handleEscapeKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && contextMenu.visible) {
        closeContextMenu();
      }
    };

    if (contextMenu.visible) {
      document.addEventListener('click', handleClickOutside);
      document.addEventListener('pointerdown', handlePressOutside, true);
      document.addEventListener('mousedown', handlePressOutside, true);
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      if (contextMenu.visible) {
        document.removeEventListener('click', handleClickOutside);
        document.removeEventListener('pointerdown', handlePressOutside, true);
        document.removeEventListener('mousedown', handlePressOutside, true);
        document.removeEventListener('keydown', handleEscapeKey);
      }
    };
  }, [contextMenu.visible, closeContextMenu]);

  return (
    <ContextMenu
      key={`${contextMenu.x}-${contextMenu.y}-${
        contextMenu.sourceId || 'default'
      }`}
      visible={contextMenu.visible}
      x={contextMenu.x}
      y={contextMenu.y}
      items={contextMenu.items}
      onClose={closeContextMenu}
    />
  );
}
